import styled from "styled-components";

export const ModalCrossIcon = styled.img`
  position: absolute;
  height: 20px;
  width: 20px;
  right: 20px;
  top: 20px;
  cursor: pointer;
  z-index: 10;

  &:hover {
    transform: scale(1.15);
    transition: transform 0.15s ease;
  }
`;
